import React from 'react';
import { containsKeywordInTable } from '@/CADUtils/functions/containsKeyword';

const IncidentInformationSection = ({
  incident,
  formatDate,
  isRedactedReport,
  redactingData,
}) => {
  const hasIncident = incident && Object.keys(incident).length > 0;

  return (
    <div className="container ">
      <div className="col-12 mb-2">
        <h6 className=" text-dark mt-2">Incident Information</h6>
        <div className="row px-3">
          {[
            { className: 'col-4 col-md-4 col-lg-4 mt-2', value: incident?.IncidentNumber, label: 'Incident Number' },
            { className: 'col-4 col-md-4 col-lg-4 mt-2', value: incident?.ReportedDate ? formatDate(incident.ReportedDate) : '', label: 'Reported Date' },
            { className: 'col-4 col-md-4 col-lg-4 mt-2', value: incident?.BIBRSDate ? formatDate(incident.BIBRSDate) : '', label: 'NIBRS Date' },
            { className: 'col-4 col-md-4 col-lg-4 mt-4', value: incident?.OccurredFrom ? formatDate(incident.OccurredFrom) : '', label: 'Occurred From' },
            { className: 'col-4 col-md-4 col-lg-4 mt-4', value: incident?.OccurredTo ? formatDate(incident.OccurredTo) : '', label: 'Occurred To' },
            { className: 'col-4 col-md-4 col-lg-4 mt-4', value: incident?.ReceiveSource, label: 'How Reported' },
            { className: 'col-4 col-md-4 col-lg-4 mt-4', value: incident?.isPoliceForceApplied, label: 'Use Of Force Applied' },
            { className: 'col-4 col-md-4 col-lg-4 mt-4', value: incident?.OfficerName, label: 'Primary Officer' },
            {
              className: 'col-9 col-md-9 col-lg-10 mt-4',
              inputClass: `readonlyColor ${isRedactedReport && containsKeywordInTable(incident?.CrimeLocation, 'CrimeLocation', 'Table3', redactingData) ? 'redacted' : ''}`,
              value: incident?.CrimeLocation,
              label: 'Crime Location',
            },
          ].map((item, index) => (
            <div className={item.className} key={index}>
              <div className="text-field">
                <input
                  type="text"
                  className={item.inputClass || 'readonlyColor'}
                  name="DocFileName"
                  required
                  readOnly
                  value={item.value}
                />
                <label htmlFor="" className="new-summary">{item.label}</label>
              </div>
            </div>
          ))}

          <div className="col-3 col-md-3 col-lg-2 mt-4 pt-3">
            <div className="">
              <input
                type="checkbox"
                name=""
                id=""
                checked={hasIncident ? incident.IsVerify : false}
                disabled={!hasIncident}
              />
              <label htmlFor="" className="new-summary pl-2">Verified</label>
            </div>
          </div>

          {[
            { className: 'col-12 col-md-12 col-lg-12 mt-4', value: incident?.OffenseType, label: 'Offense Type', name: 'DocFileName' },
            { className: 'col-12 col-md-12 col-lg-12 mt-4', value: incident?.RMS_Disposition, label: 'Exceptional Clearance(Yes/No)', name: '' },
            { className: 'col-6 col-md-6 col-lg-6 mt-4', value: incident?.NIBRSClearance, label: 'Exceptional Clearance Code', name: '' },
            { className: 'col-6 col-md-6 col-lg-6 mt-4', value: incident?.NIBRSclearancedate ? formatDate(incident.NIBRSclearancedate) : '', label: 'Exceptional Clearance Date/Time', name: '' },
            { className: 'col-6 col-md-6 col-lg-6 mt-4', value: incident?.CADCFSCode_Description, label: 'CAD CFS Code', name: '' },
            { className: 'col-6 col-md-6 col-lg-6 mt-4', value: incident?.CADDispositions_Description, label: 'CAD Dispositions', name: '' },
          ].map((item, index) => (
            <div className={item.className} key={index}>
              <div className="text-field">
                <input
                  type="text"
                  className={item.inputClass || 'readonlyColor'}
                  name={item.name || ''}
                  required
                  readOnly
                  value={item.value}
                />
                <label htmlFor="" className="new-summary">{item.label}</label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IncidentInformationSection;
